import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import { BRANDS_CATEGORY_ID } from "@faire/help-center-utils/consts/BRANDS_CATEGORY_ID";
import { RETAILERS_CATEGORY_ID } from "@faire/help-center-utils/consts/RETAILERS_CATEGORY_ID";
import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import { useCustomerType } from "@faire/help-center/hooks/useCustomerType";
import { useArticlesDataFetch } from "@faire/help-center/views/articles/hooks/useArticlesDataFetch";
import { useQuery as useZendeskSections } from "@faire/web-api/api/zendesk/locale/sections/get-hooks";
import { route as homeRoute } from "@faire/web-api/routes/support";
import { route as brandsRoute } from "@faire/web-api/routes/support/brands";
import { route as retailersRoute } from "@faire/web-api/routes/support/retailers";
import { route as searchPageRoute } from "@faire/web-api/routes/support/search";
import topicPage from "@faire/web-api/routes/support/topics/topicId";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";
import { localBreadcrumbs } from "../localBreadcrumbs";
var isBrandTopicCategory = function isBrandTopicCategory(topic) {
  return topic.category_id === BRANDS_CATEGORY_ID;
};
var BrandLinkData = function BrandLinkData(strictLocalize) {
  return {
    name: localBreadcrumbs(strictLocalize).BRAND_GUIDES,
    to: brandsRoute
  };
};
var RetailerLinkData = function RetailerLinkData(strictLocalize) {
  return {
    name: localBreadcrumbs(strictLocalize).RETAILER_GUIDES,
    to: retailersRoute
  };
};
export var usePath = function usePath() {
  var _pathname$includes, _sectionsResponse$sec;
  var location = useLocation();
  var pathname = location.pathname;
  var _useCustomerType = useCustomerType(),
    customerType = _useCustomerType.customerType;
  var _useArticlesDataFetch = useArticlesDataFetch(),
    article = _useArticlesDataFetch.article,
    inHiddenSection = _useArticlesDataFetch.inHiddenSection,
    articleSection = _useArticlesDataFetch.articleSection,
    isLoading = _useArticlesDataFetch.isLoading;
  var isBasePath = pathMatchesRoute(pathname, homeRoute);
  var isBrandBasePath = pathMatchesRoute(pathname, brandsRoute);
  var isRetailerBasePath = pathMatchesRoute(pathname, retailersRoute);
  var isPopularGuidesPath = (_pathname$includes = pathname.includes("popular-guides")) !== null && _pathname$includes !== void 0 ? _pathname$includes : false;
  // pathMatchesRoute won't work here because the search route has a query param
  var isSearchPath = pathname.startsWith(searchPageRoute);
  var isBrandPath = function isBrandPath(ctx) {
    var urlContainsBrandsCategory = (location === null || location === void 0 ? void 0 : location.search.includes("".concat(BRANDS_CATEGORY_ID))) || (location === null || location === void 0 ? void 0 : location.pathname.includes("".concat(BRANDS_CATEGORY_ID)));
    if (isBrandBasePath || urlContainsBrandsCategory) {
      return true;
    }
    var isBrandArticle = customerType === CustomerTypes.BRAND;
    var isBrandTopic = ctx.topic ? isBrandTopicCategory(ctx.topic) : false;
    return !ctx.topicsLoading && (isBrandArticle || isBrandTopic);
  };
  var getUserTypeLink = function getUserTypeLink(ctx, strictLocalize) {
    return isBrandPath(ctx) ? BrandLinkData(strictLocalize) : RetailerLinkData(strictLocalize);
  };
  var _useZendeskSections = useZendeskSections(localeString),
    sectionsResponse = _useZendeskSections.data;
  var currentSection = sectionsResponse === null || sectionsResponse === void 0 ? void 0 : (_sectionsResponse$sec = sectionsResponse.sections) === null || _sectionsResponse$sec === void 0 ? void 0 : _sectionsResponse$sec.filter(function (section) {
    return section.id === Number(article === null || article === void 0 ? void 0 : article.section_id);
  });
  var getBreadcrumbPaths = function getBreadcrumbPaths(ctx, strictLocalize) {
    var paths = [{
      name: localBreadcrumbs(strictLocalize).HOME,
      to: homeRoute
    }];
    if (isBrandBasePath) {
      paths.push(BrandLinkData(strictLocalize));
    } else if (isRetailerBasePath) {
      paths.push(RetailerLinkData(strictLocalize));
    } else if (isPopularGuidesPath) {
      paths.push(getUserTypeLink(ctx, strictLocalize));
      paths.push({
        name: localBreadcrumbs(strictLocalize).POPULAR_GUIDES,
        to: ""
      });
    } else if (isSearchPath) {
      paths.push(getUserTypeLink(ctx, strictLocalize));
      paths.push({
        name: localBreadcrumbs(strictLocalize).SEARCH,
        to: ""
      });
    } else if (!ctx.topicsLoading && ctx.topic) {
      var _ctx$topic$name;
      paths.push(isBrandTopicCategory(ctx.topic) ? BrandLinkData(strictLocalize) : RetailerLinkData(strictLocalize));
      paths.push({
        name: (_ctx$topic$name = ctx.topic.name) !== null && _ctx$topic$name !== void 0 ? _ctx$topic$name : "",
        to: ""
      });
    } else if (!ctx.topicsLoading && article) {
      var _article$name;
      paths.push(customerType === CustomerTypes.BRAND ? BrandLinkData(strictLocalize) : RetailerLinkData(strictLocalize));
      if (!inHiddenSection) {
        var _ref, _articleSection$name, _currentSection$;
        paths.push({
          name: (_ref = (_articleSection$name = articleSection === null || articleSection === void 0 ? void 0 : articleSection.name) !== null && _articleSection$name !== void 0 ? _articleSection$name : currentSection === null || currentSection === void 0 ? void 0 : (_currentSection$ = currentSection[0]) === null || _currentSection$ === void 0 ? void 0 : _currentSection$.name) !== null && _ref !== void 0 ? _ref : "",
          to: topicPage("".concat(article.section_id))
        });
      }
      paths.push({
        name: (_article$name = article.name) !== null && _article$name !== void 0 ? _article$name : "",
        to: ""
      });
    }
    return paths;
  };
  var getCategoryId = function getCategoryId(ctx) {
    return isBrandPath(ctx) ? BRANDS_CATEGORY_ID : RETAILERS_CATEGORY_ID;
  };
  return {
    isBasePath: isBasePath,
    isBrandBasePath: isBrandBasePath,
    isRetailerBasePath: isRetailerBasePath,
    isPopularGuidesPath: isPopularGuidesPath,
    isSearchPath: isSearchPath,
    isBrandPath: isBrandPath,
    getBreadcrumbPaths: getBreadcrumbPaths,
    getCategoryId: getCategoryId,
    isLoading: isLoading
  };
};